import { Injectable } from '@angular/core';
import { STORAGE_KEYS } from '@core/configs/app.constants';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageStoreService {
  appSyncUrl             = generateLocalStorageItemManager(STORAGE_KEYS.APP_SYNC_URL);
  userPoolId             = generateLocalStorageItemManager(STORAGE_KEYS.USER_POOL_ID);
  appClientId            = generateLocalStorageItemManager(STORAGE_KEYS.APP_CLIENT_ID);
  apiGatewayUrl          = generateLocalStorageItemManager(STORAGE_KEYS.API_GATEWAY_URL);
  notificationGraphqlUrl = generateLocalStorageItemManager(STORAGE_KEYS.NOTIFICATION_GRAPHQL_URL);

  constructor() { }
}

function generateLocalStorageItemManager(key: string): LocalStorageItemManager {
  return {
    get: () => localStorage.getItem(key),
    clear: () => localStorage.removeItem(key),
    set: (value: string) => localStorage.setItem(key, value)
  }
}

interface LocalStorageItemManager {
  get: () => string;
  set: (value: string) => void;
  clear: () => void;
}
